<!-- payMethodsList -->
<template>
  <div :class="{ payMethodGroups: grouped }">
    <div
      v-for="group in displayGroups"
      :key="group.key"
      :class="{ payMethodGroup: grouped }"
    >
      <p v-if="grouped" class="groupTitle">{{ group.title }}</p>
      <ul class="payMethodsList">
        <li
          v-for="(payMethod, index) in group.list"
          :key="index"
          @click.stop="methodSelect(payMethod)"
          class="payMethod"
        >
          <div
            class="mainPart"
            v-if="
              !($root.$data.isWeiXin && (payMethod.type === 'alipay' || payMethod.type === 'huabei'))
            "
          >
            <p class="payMethodText">
              <img :src="payMethod.icon" class="payMethodIcon" />
              <span class="text">{{ payMethodsMap[payMethod.type] }}</span>
            </p>
            <i :class="['selectIcon', { selecting: payMethod.active }]"></i>
          </div>
          <ul
            v-if="payMethod.type === huabeiType && huabeiList && huabeiList.length"
            v-show="(payMethodsList.find(payMethod => payMethod.active) || {}).type === huabeiType"
            class="huabeiDetailList"
          >
            <li
              v-for="(huabeiDetail, index) in huabeiList"
              :key="index"
              :class="['huabeiDetail', { selecting: huabeiDetail.active }]"
              @click.stop="huabeiSelect(payMethod, huabeiDetail, 1)"
            >
              <p class="payTotal">
                <span class="currency">￥</span>
                <span class="price">{{ huabeiDetail.eachPrincipal }} </span>
                <span class="symbol">× </span>
                <span class="quantity">{{ huabeiDetail.payableNum }} </span>
                <span class="text">期</span>
              </p>
              <p class="commission">
                <span>手续费：</span>
                <span>{{ huabeiDetail.eachFee }}元/期</span>
              </p>
              <p class="rate">
                <span>费率：</span>
                <span>{{ huabeiDetail.rate }}</span>
              </p>
            </li>
          </ul>
          <ul
            v-if="
              payMethod.type === baitiaoType &&
                baitiaoList &&
                baitiaoList.length
            "
            v-show="(payMethodsList.find(payMethod => payMethod.active) || {}).type === baitiaoType"
            class="huabeiDetailList"
          >
            <li
              v-for="(huabeiDetail, index) in baitiaoList"
              :key="index"
              :class="['huabeiDetail', { selecting: huabeiDetail.active }]"
              @click.stop="huabeiSelect(payMethod, huabeiDetail, 2)"
            >
              <p class="payTotal">
                <span class="currency">￥</span>
                <span class="price">{{ huabeiDetail.eachPrincipal }} </span>
                <span class="symbol">× </span>
                <span class="quantity">{{ huabeiDetail.payableNum }} </span>
                <span class="text">期</span>
              </p>
              <p class="commission">
                <span>手续费：</span>
                <span>{{ huabeiDetail.eachFee }}元/期</span>
              </p>
              <p class="rate">
                <span>费率：</span>
                <span>{{ huabeiDetail.rate }}</span>
              </p>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { payMethodsMap, HUABEI_TYPE, BAITIAO_TYPE } from '@/assets/js/payConfig';

const TOOL_ORDER = {
  wechat: 0,
  alipay: 1,
  jd: 2,
};

export default {
  props: {
    payMethodsList: {
      type: Array,
      default: () => [],
    },
    huabeiList: {
      type: Array,
      default: () => [],
    },
    baitiaoList: {
      type: Array,
      default: () => [],
    },
    grouped: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      payMethodsMap,
      huabeiType: HUABEI_TYPE,
      baitiaoType: BAITIAO_TYPE,
      tempSelected: null,
    };
  },
  computed: {
    displayGroups() {
      if (!this.grouped) {
        return [{ key: 'all', title: '', list: this.payMethodsList }];
      }
      const groups = [];
      const toolList = this.payMethodsList
        .filter((item) => item.type !== this.huabeiType && this.isPayMethodVisible(item))
        .sort((a, b) => (TOOL_ORDER[a.type] ?? 99) - (TOOL_ORDER[b.type] ?? 99));
      const financeList = this.payMethodsList.filter(
        (item) => item.type === this.huabeiType && this.isPayMethodVisible(item),
      );
      if (toolList.length) {
        groups.push({ key: 'tool', title: '支付工具', list: toolList });
      }
      if (financeList.length) {
        groups.push({ key: 'finance', title: '金融工具', list: financeList });
      }
      return groups;
    },
  },
  methods: {
    isPayMethodVisible(payMethod) {
      return !(this.$root.$data.isWeiXin && (payMethod.type === 'alipay' || payMethod.type === 'huabei'));
    },
    statusInit() {
      if (this.payMethodsList.every((payMethod) => !payMethod.active) && this.payMethodsList.length) {
        this.payMethodsList[0].active = true;
      }
      if (
        (this.payMethodsList.find((payMethod) => payMethod.active) || {}).type === this.huabeiType
      ) {
        if (this.huabeiList.every((huabeiDetail) => !huabeiDetail.active) && this.huabeiList.length) {
          this.huabeiList[0].active = true;
        }
      }
      if (
        (this.payMethodsList.find((payMethod) => payMethod.active) || {}).type === this.baitiaoType
      ) {
        if (
          this.baitiaoList.every((huabeiDetail) => !huabeiDetail.active)
          && this.baitiaoList.length
        ) {
          this.baitiaoList[0].active = true;
        }
      }
    },
    methodSelect(selectedPayMethod) {
      this.payMethodsList.forEach((payMethod) => {
        Object.assign(payMethod, { active: false });
      });
      Object.assign(selectedPayMethod, { active: true });
      if (selectedPayMethod.type === this.huabeiType) {
        this.huabeiList.forEach((item) => {
          this.$set(item, 'active', false);
        });
        this.huabeiList[0].active = true;
      }
      if (selectedPayMethod.type === this.baitiaoType) {
        this.baitiaoList.forEach((item) => {
          this.$set(item, 'active', false);
        });
        this.baitiaoList[0].active = true;
      }
    },
    huabeiSelect(payMethod, selectedHuabeiDetail, type) {
      if (type === 1) {
        this.huabeiList.forEach((item) => {
          this.$set(item, 'active', false);
          if (item.payableNum === selectedHuabeiDetail.payableNum) {
            this.$set(item, 'active', true);
          }
        });
      } else {
        this.baitiaoList.forEach((item) => {
          this.$set(item, 'active', false);
          if (item.payableNum === selectedHuabeiDetail.payableNum) {
            this.$set(item, 'active', true);
          }
        });
      }
    },
  },
  created() {
    this.statusInit();
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.payMethodGroups {
  .payMethodGroup {
    margin-bottom: 24px;
    padding: 8px 24px 16px;
    background: #fff;
    border-radius: 24px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .groupTitle {
    padding: 24px 0 8px;
    font-weight: bold;
    font-size: 29px;
    line-height: 40px;
  }

  .payMethod:last-child {
    border-bottom: none;
  }
}

.payMethodsList {
  .payMethod {
    border-bottom: 2px solid #f5f5f6;

    .mainPart {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 94px;

      .payMethodText {
        display: flex;
        align-items: center;

        .payMethodIcon {
          width: 43px;
          height: 43px;
          margin-right: 14px;
        }

        .text {
          color: #333;
          font-size: 25px;
        }
      }

      .selectIcon {
        width: 43px;
        height: 43px;
        background: url('../../../assets/img/payment/unselect.png') no-repeat center;
        background-size: contain;

        &.selecting {
          background-image: url('../../../assets/img/payment/selected.png');
        }
      }
    }

    .huabeiDetailList {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .huabeiDetail {
        width: calc(50% - 10px);
        height: 152px;
        margin-bottom: 40px;
        padding: 14px;
        background: url('../../../assets/img/payment/unselect_huabei.png') no-repeat center;
        background-size: 100% 100%;

        .payTotal {
          margin-bottom: 14px;
          font-size: 29px;
          line-height: 40px;

          .text {
            color: #333;
            font-style: initial;
          }

          .currency {
            font-size: 20px;
          }

          .currency,
          .price,
          .quantity {
            color: #ff6c02;
          }
        }

        .commission,
        .rate {
          display: flex;
          height: 31px;
          margin-bottom: 7px;
          color: #787878;
          font-size: 22px;
          line-height: 31px;

          span {
            min-width: 107px;
          }
        }

        &.selecting {
          background-color: rgba(255, 108, 2, 0.003);
          background-image: url('../../../assets/img/payment/selected_huabei.png');
        }
      }
    }
  }
}
</style>
